import { useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';


const useUpdateGroupe = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const updateGroupe = async (groupeId, groupeData) => {
        setIsLoading(true);
        setError(null);
        const csrfToken = Cookies.get('csrftoken');

        try {
            const response = await axios.patch(groupeId, groupeData, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                withCredentials:true,
            });

            setIsLoading(false);
            return response.data;
        } catch (error) {
            setError(error);
            setIsLoading(false);
            console.error("Erreur lors de la mise à jour du groupe :", error);
            // ✅ Faire remonter l'erreur pour qu'elle soit capturée dans savePrenom
            throw error;
        }
    };

    return { updateGroupe, isLoading, error };
};

export default useUpdateGroupe;